const colors = {
  white: '#FFFFFF',
  whisperWhite: '#FBFBFD',
  darkGrey: '#25272B',
  slateGrey: '#5F6368',
  blue: '#4D7AFF',
  mysticGrey: '#EDF0F5',
  royalBlue: '#456DE6',
  crimsonRed: '#D31045',
};
export default colors;
